module.exports = __webpack_public_path__ + "img/titleist_a_visual_m.082c1cce.jpg";